import { create } from 'zustand';

type ActiveTab = 'conversation' | 'history';

interface PreviewExpert {
  id: string;
  name: string;
  color: string;
}

interface AIAgentStore {
  previewExpert: PreviewExpert | undefined;
  setPreviewExpert: (expert: PreviewExpert | undefined) => void;

  eddyDrawerIsOpen: boolean;
  setEddyDrawerIsOpen: (open: boolean) => void;
  showWelcome: boolean;
  setShowWelcome: (show: boolean) => void;
  activeTab: ActiveTab;
  setActiveTab: (tab: ActiveTab) => void;
  currentConversationId: string;
  setCurrentConversationId: (id: string) => void;
  isConversationActive: boolean;
  setIsConversationActive: (active: boolean) => void;
  completedTypingExchanges: Set<string>;
  setCompletedTypingExchanges: (
    exchanges: Set<string> | ((prev: Set<string>) => Set<string>),
  ) => void;
  renderNudgePopup: boolean;
  setRenderNudgePopup: (render: boolean) => void;
}

export const useAIAgentStore = create<AIAgentStore>((set) => ({
  previewExpert: undefined,
  setPreviewExpert: (expert) => set({ previewExpert: expert }),
  eddyDrawerIsOpen: false,
  setEddyDrawerIsOpen: (open) => set({ eddyDrawerIsOpen: open }),
  showWelcome: true,
  setShowWelcome: (show) => set({ showWelcome: show }),
  activeTab: 'history',
  setActiveTab: (tab) => set({ activeTab: tab }),
  currentConversationId: '',
  setCurrentConversationId: (id) => set({ currentConversationId: id }),
  isConversationActive: false,
  setIsConversationActive: (active) => set({ isConversationActive: active }),
  completedTypingExchanges: new Set(),
  setCompletedTypingExchanges: (exchanges) =>
    set((state) => ({
      completedTypingExchanges:
        typeof exchanges === 'function' ? exchanges(state.completedTypingExchanges) : exchanges,
    })),
  renderNudgePopup: false,
  setRenderNudgePopup: (render) => set({ renderNudgePopup: render }),
}));
